import styled from 'styled-components';

import { DEVICE } from '@hero/constants';

const HomeTemplate = styled.div`
  .swiper-button-next:after,
  .swiper-button-prev:after {
    font-size: 18px;
  }
`;

const Categories = styled.section`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;

  ${DEVICE.mobile.max} {
    background-color: transparent;
    padding: 0;
  }
`;

export { Categories, Content, HomeTemplate };
